export const routes = (prefix = `admissions`) => [
    {
        path: `/${prefix}/pending-discharge`,
        name: `${prefix}.pending-discharge.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.pending-discharge.index`,
                PageDescription: `Admissions - Pending Discharge`,
            },
        },
    },
    {
        path: `/${prefix}/print/:visitID`,
        name: `${prefix}.discharge-request.print`,
        component: () => import('./prints/dischargerequest.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.pending-discharge.index`,
                PageDescription:  `Admissions - Pending Discharge`,
            },
            print: true,
        },
    },
];
